import { fetchWrapper } from '@/_helpers';

const BASE_URL = 'userformdata/discussions';

export const userformdataDiscussionApi = {
    getDiscussions: (userformdataId) => {
        return fetchWrapper.get(`${BASE_URL}/${userformdataId}`);
    },
    createDiscussion: (userformdataId, payload) => {
        return fetchWrapper.post(`${BASE_URL}/${userformdataId}`, payload);
    },
    getNotifications: (userformdataId) => {
        return fetchWrapper.get(`${BASE_URL}/${userformdataId}/notifications`);
    },
    updateNotifications: (userformdataId, payload) => {
        return fetchWrapper.put(`${BASE_URL}/${userformdataId}/notifications`, payload);
    },
};
